// src/docs/DocsTermsAgreements.js
import React from "react";
import { Container, Typography, Box } from "@mui/material";

const DocsTermsAgreements = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 2 }}>
        Terms & Agreements
      </Typography>

      {/* Introduction */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 2 }}>
        Before you begin using CrowdLaunch, please review our Terms & Conditions carefully.
        These terms outline your responsibilities, our limitations of liability, and the rules that govern
        the use of our platform. Accepting these terms is essential to ensure a safe and transparent experience.
      </Typography>

      {/* Disclaimer and Terms */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Disclaimer and Terms
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        CrowdLaunch is a platform that facilitates the launch and display of innovative projects. We do not
        endorse or guarantee the accuracy or viability of the projects hosted on our platform. Your use of
        the information provided is strictly at your own risk.
      </Typography>

      {/* User Responsibility and Due Diligence */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        User Responsibility and Due Diligence
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        It is your responsibility to conduct independent research and due diligence ("DYOR") before
        engaging with any project. CrowdLaunch does not provide financial, legal, or investment advice.
      </Typography>

      {/* Assumption of Risk */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Assumption of Risk
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        All investments and engagements with projects on CrowdLaunch involve inherent risks, including scams,
        technical failures, and unforeseen market fluctuations. By using our platform, you acknowledge these risks.
      </Typography>

      {/* Limitation of Liability */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Limitation of Liability
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        CrowdLaunch, its affiliates, directors, officers, employees, and agents will not be held liable for any
        direct, indirect, incidental, special, or consequential damages arising from your use of the platform.
      </Typography>

      {/* Indemnification */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Indemnification
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        You agree to indemnify, defend, and hold harmless CrowdLaunch and its affiliates from any claims,
        damages, or losses arising from your use of the platform or your reliance on any information provided.
      </Typography>

      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mt: 3 }}>
        By clicking “Accept” on the CrowdLaunch interface, you confirm that you have read, understood, and
        agree to be bound by these Terms & Conditions. Your acceptance is essential for accessing all the
        features of the platform.
      </Typography>

    </Container>
  );
};

export default DocsTermsAgreements;
